module.exports = __webpack_public_path__ + "static/media/logo.637efd5b.png";